<template>
    <div>
    <div class="py-3"></div>
    
    <!-- 텍스트 퀴즈 업로드 (탭으로 구분) -->
    <v-card
        class="mx-auto"
        max-width="90%"
    >
    <v-toolbar
        :color="'light-blue darken-3'"
        dark
    >    
    <v-toolbar-title>텍스트 퀴즈 업로드</v-toolbar-title>
    <v-spacer></v-spacer>
    </v-toolbar>
    
    <v-tabs
        v-model="textQuizTab"
        color="primary"
        slider-color="primary"
    >
        <v-tab>가로세로</v-tab>
        <v-tab>객관식퀴즈</v-tab>
        <v-tab>넌센스</v-tab>
        <v-tab>OX</v-tab>
    </v-tabs>
    
    <v-tabs-items v-model="textQuizTab">
        <!-- 가로세로 퀴즈 탭 -->
        <v-tab-item>
            <v-list>
                <v-list-item>
                    <span style="width:200px"><v-card-title style="font-weight:bold">템플릿 업로드</v-card-title></span>
                    <span style="width:60%">                      
                    <v-file-input
                        label="HV_Quiz.json 파일업로드"
                        v-model="inputTemplate_HVQuiz"
                        :multiple="false"
                         accept=".json,application/json"
                        @change="(file) => onFileChange_HV_Quiz(file)"
                    ></v-file-input> 
                    </span>
                </v-list-item>   
                <v-divider/>     
                <v-list-item>       
                    <v-spacer></v-spacer>
                    <v-btn
                         color= "blue-grey darken-1"
                        dark
                        small
                        @click="openQuizLink_HV"
                        class="mr-2"
                    >
                        링크확인
                    </v-btn>
                    <v-btn v-if="enableUplaod_HVQuiz" width="120px"  color="lime accent-3"  @click="upload_HV_Quiz">템플릿 업로드</v-btn>
                    <v-btn v-else width="120px"  color="grey" style="color: white; font-weight: 700;" >템플릿 업로드</v-btn>
                    <v-spacer></v-spacer>
                </v-list-item>    
            </v-list>
        </v-tab-item>
        
        <!-- 낱말 퀴즈 탭 -->
        <v-tab-item>
            <v-list>
                <v-list-item>
                    <span style="width:200px"><v-card-title style="font-weight:bold">템플릿 업로드</v-card-title></span>
                    <span style="width:60%">                      
                    <v-file-input
                        label="Select_Quiz.json 파일업로드"
                        v-model="inputTemplate_SelectQuiz"
                        :multiple="false"
                         accept=".json,application/json"
                        @change="(file) => onFileChange_Select_Quiz(file)"
                    ></v-file-input> 
                    </span>
                </v-list-item>   
                <v-divider/>     
                <v-list-item>       
                    <v-spacer></v-spacer>
                    <v-btn
                         color= "blue-grey darken-1"
                        dark
                        small
                        @click="openQuizLink_Select"
                        class="mr-2"
                    >
                        링크확인
                    </v-btn>
                    <v-btn v-if="enableUplaod_SelectQuiz" width="120px"  color="lime accent-3"  @click="upload_Select_Quiz">템플릿 업로드</v-btn>
                    <v-btn v-else width="120px"  color="grey" style="color: white; font-weight: 700;" >템플릿 업로드</v-btn>
                    <v-spacer></v-spacer>
                </v-list-item>    
            </v-list>
        </v-tab-item>
        
        <!-- 넌센스 퀴즈 탭 -->
        <v-tab-item>
            <v-list>
                <v-list-item>
                    <span style="width:200px"><v-card-title style="font-weight:bold">템플릿 업로드</v-card-title></span>
                    <span style="width:60%">                      
                    <v-file-input
                        label="Nonsense_Quiz.json 파일업로드"
                        v-model="inputTemplate_NonsenseQuiz"
                        :multiple="false"
                         accept=".json,application/json"
                        @change="(file) => onFileChange_Nonsense_Quiz(file)"
                    ></v-file-input> 
                    </span>
                </v-list-item>   
                <v-divider/>     
                <v-list-item>       
                    <v-spacer></v-spacer>
                    <v-btn
                         color= "blue-grey darken-1"
                        dark
                        small
                        @click="openQuizLink_Nonsense"
                        class="mr-2"
                    >
                        링크확인
                    </v-btn>
                    <v-btn v-if="enableUplaod_NonsenseQuiz" width="120px"  color="lime accent-3"  @click="upload_Nonsense_Quiz">템플릿 업로드</v-btn>
                    <v-btn v-else width="120px"  color="grey" style="color: white; font-weight: 700;" >템플릿 업로드</v-btn>
                    <v-spacer></v-spacer>
                </v-list-item>    
            </v-list>
        </v-tab-item>
        
        <!-- OX 퀴즈 탭 -->
        <v-tab-item>
            <v-list>
                <v-list-item>
                    <span style="width:200px"><v-card-title style="font-weight:bold">템플릿 업로드</v-card-title></span>
                    <span style="width:60%">                      
                    <v-file-input
                        label="OX_Quiz.json 파일업로드"
                        v-model="inputTemplate_OXQuiz"
                        :multiple="false"
                         accept=".json,application/json"
                        @change="(file) => onFileChange_OX_Quiz(file)"
                    ></v-file-input> 
                    </span>
                </v-list-item>   
                <v-divider/>     
                <v-list-item>       
                    <v-spacer></v-spacer>
                    <v-btn
                         color= "blue-grey darken-1"
                        dark
                        small
                        @click="openQuizLink_OX"
                        class="mr-2"
                    >
                        링크확인
                    </v-btn>
                    <v-btn v-if="enableUplaod_OXQuiz" width="120px"  color="lime accent-3"  @click="upload_OX_Quiz">템플릿 업로드</v-btn>
                    <v-btn v-else width="120px"  color="grey" style="color: white; font-weight: 700;" >템플릿 업로드</v-btn>
                    <v-spacer></v-spacer>
                </v-list-item>    
            </v-list>
        </v-tab-item>
    </v-tabs-items>
    </v-card>
    
    <div class="py-3"></div>
    <div class="py-3"></div>

    <!-- 그림 퀴즈 관리 -->
    <v-card
        class="mx-auto"
        max-width="90%"
    >
    <v-toolbar
        :color="'light-blue darken-3'"
        dark
    >    
    <v-toolbar-title>그림 퀴즈 관리</v-toolbar-title>
        <v-spacer/>
        <v-btn
            color="cyan"
            small
            fab
            @click="OnClick_CreateDrawingQuiz"
        >
            <v-icon 
            color= "white"
            >mdi-plus</v-icon>
        </v-btn>
    </v-toolbar>

    <v-list>
        <v-data-table
            :footer-props="{'items-per-page-options': [-1]}"
            :headers="drawingQuizHeaders"
            :items="drawingQuizList"
            :loading="loadingDrawingQuiz"
        >
            <template v-slot:item="{ item, index }">
            <tr :class="{ 'error-row': !isDrawingQuizValid(item) }">
                <!-- Index 표시 -->
                <td><v-col style="width: 60px;">{{ item.pid }} <span style="font-weight: 900;">({{drawingQuizList.length - index}})</span></v-col></td>

                <!-- 이미지 미리보기 -->
                <td>
                <img
                    v-if="item.img_path"
                    :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/' + item.img_path" 
                    alt="Image"
                    style="width: 120px; height: 60px; border: 2px solid black; border-radius: 10px; margin-top: 5px;"
                />
                <div v-else style="width: 120px; height: 60px; border: 2px solid red; border-radius: 10px; margin-top: 5px; display: flex; align-items: center; justify-content: center; background-color: #ffebee;">
                    <span style="color: red; font-weight: bold;">이미지 없음</span>
                </div>
                </td>

                <!-- 정답 표시 -->
                <td>
                <span style="font-weight: bold;">{{ item.correct }}</span>
                </td>

                <!-- 선택지 표시 -->
                <td>
                <span>{{ item.answer }}</span>
                </td>

                <!-- 수정 버튼 -->
                <td>
                <v-btn
                    width="60px"
                    color="blue"
                    class="white--text"
                    @click="OnEditDrawingQuiz_Item(item)"
                >
                    수정
                </v-btn>
                </td>

                <!-- 삭제 버튼 -->
                <td>
                <v-btn
                    width="60px"
                    color="red"
                    class="white--text"
                    @click="OnDeleteDrawingQuiz_Item(item)"
                >
                    삭제
                </v-btn>
                </td>
            </tr>
            </template>
        </v-data-table>
        </v-list>

    </v-card>

    <!-- 그림 퀴즈 등록/수정 다이얼로그 -->
    <v-dialog
      v-model="drawingQuizDialog"
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-h5 mb-3">
            {{ editingDrawingQuizItem ? '그림 퀴즈 수정하기' : '그림 퀴즈 등록하기' }}
        </v-card-title>

        <v-card-text>
            <v-row>
                <!-- 이미지 업로드 입력 -->
                <v-col cols="12">
                    <v-file-input
                        label="그림 이미지 (380*380)"
                        accept="image/*"
                        v-model="drawingQuizImageFile"
                        prepend-icon="mdi-image"
                        outlined
                        @change="handleDrawingQuizFileChange"
                    />
                    <!-- 수정 모드일 때 현재 이미지 미리보기 -->
                    <div v-if="editingDrawingQuizItem && !drawingQuizImageFile" class="mt-2">
                        <p class="mb-1">현재 이미지:</p>
                        <img
                            :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/' + editingDrawingQuizItem.img_path"
                            alt="Current Image"
                            style="width: 200px; height: 200px; border: 2px solid #ddd; border-radius: 10px;"
                        />
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="3" class="text-center font-weight-bold text-h6">정답</v-col>
                <v-col>
                    <v-text-field 
                        label="정답을 입력해주세요"
                        v-model="drawingQuizDialog_correct" 
                        outlined
                        dense
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="3" class="text-center font-weight-bold text-h6">선택지</v-col>
                <v-col>
                    <v-text-field 
                        label="선택지를 입력해주세요"
                        v-model="drawingQuizDialog_answer" 
                        outlined
                        dense
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="CancelDrawingQuizEdit"
          >
            취소
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="editingDrawingQuizItem ? SaveDrawingQuiz() : CreateDrawingQuiz()"
          >
            저장
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- <v-card
        class="mx-auto"
        max-width="90%"
    >
    <v-toolbar
        :color="'grey darken-1'"
        dark
    >    
    <v-toolbar-title>테이블 업로드 이력</v-toolbar-title>
    </v-toolbar>
    <v-list>
        <v-data-table         
        :footer-props="{'items-per-page-options':[20, 50, -1]}"
        :headers="headers" 
        :items="history_all"
        :loading="loadingData"
        >        
        <template v-slot:item="row">            
            <tr>
            <td>{{row.item.VERSION}}</td>
            <td>{{row.item.ADMIN}}</td>
            <td>{{row.item.REG_DT}}</td>
            <td>{{row.item.COMMENT}}</td>
            <td>{{OS_TagConvert(row.item.OS)}}</td>
            <td>
                <v-btn 
                class="mx-2" 
                fab 
                dark 
                small 
                color="indigo lighten-3"
                :href="downloadUrl + row.item.FILE_PATH"
                download
                >
                    <v-icon dark>mdi-tray-arrow-down</v-icon>
                </v-btn>
            </td>         
            </tr>
        </template>
        </v-data-table>
    </v-list>
    </v-card> -->
    </div>   
    
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment'
import store from '../../store';
import config from '../../config/config';
import { format, parseISO } from 'date-fns'
const { s3_upload , FileUpload_Async, FileUpload_JSON} = require("../../util/fileutil");

export default {
    name: 'UserList',

    data: () => ({
        textQuizTab: 0, // 텍스트 퀴즈 탭 인덱스
        inputTemplate_HVQuiz:null,
        enableUplaod_HVQuiz:false,
        inputTemplate_SelectQuiz:null,
        enableUplaod_SelectQuiz:false,
        inputTemplate_NonsenseQuiz:null,
        enableUplaod_NonsenseQuiz:false,
        inputTemplate_OXQuiz:null,
        enableUplaod_OXQuiz:false,
        // 그림 퀴즈 관리
        drawingQuizList: [],
        loadingDrawingQuiz: false,
        drawingQuizDialog: false,
        drawingQuizImageFile: null,
        drawingQuizDialog_correct: '',
        drawingQuizDialog_answer: '',
        editingDrawingQuizItem: null,
        drawingQuizHeaders: [
            { text: '고유번호', value: 'pid' },
            { text: '이미지', value: 'img_path' },           
            { text: '정답', value: 'correct' },            
            { text: '선택지', value: 'answer' },
            { text: '수정', value: 'edit' },
            { text: '삭제', value: 'delete' },
        ],
    }),

    created()
    {
        this.date_end = moment().add(3,'M').format('yyyy-MM-DD');
        this.LoadDrawingQuizList();
    },

    methods:{
        ...mapActions([
            // 'GET_TEMPLATE_LOG',
            // 'INSERT_TEMPLATE_LOG'
            'GET_DRAWING_QUIZ_LIST',
            'CREATE_DRAWING_QUIZ',
            'EDIT_DRAWING_QUIZ',
            'DELETE_DRAWING_QUIZ',
        ]),
    
        OnUpload_Template(quiz_type)
        {
            if(quiz_type == "HV_Quiz"){
                alert("알수없는 퀴즈 타입입니다.");
            }
            else if(quiz_type == "Select_Quiz"){
                alert("알수없는 퀴즈 타입입니다.");
            }
            else{
                alert("알수없는 퀴즈 타입입니다.");
                return;
            }
            
            console.log("OnUpload_Template " + JSON.stringify(this.inputTemplate_HVQuiz));
            //function s3_upload_tempalte(this.inputTemplate, _fileName , _listener)
            let packageName = this.$store.state.selected_game_package;
            let templateVer = this.templateVer;
            let comment = this.comment;
            let serverState= "dev";
            if(this.isLive)
                serverState = "live";
            else
                serverState = "dev";
                
            let fileName = this.CreateRandomFileName();
            let file_path = `CommonTemplate/${serverState}/${packageName.replaceAll('.', '_')}/${fileName}`;
            console.log(file_path);
            ///file_path = "CommonTemplate/test";
            let isIOS = (this.isIOS == false)?0:1;
        },
      
        CreateRandomFileName()
        {
            let baseStrContainer = '123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            let charactersLength = baseStrContainer.length;
            let randomString = '';
            for (var i = 0; i < 16; i++) {
                //return Math.random() * (max - min) + min;
                randomString += baseStrContainer.charAt(this.getRandomArbitrary(0, charactersLength - 1));
            }
            return randomString;
        },

        getRandomArbitrary(min, max) {
            return Math.random() * (max - min) + min;
        },

        OnRemoveItem(_index)
        {
            this.selected_itemList[_index] = undefined;
            this.Refresh_ItemInfo();
        },
        onFileChange_HV_Quiz(file) {
            console.log("onFileChange_HV_Quiz 1");
            const f = Array.isArray(file) ? file[0] : file;
            this.enableUplaod_HVQuiz = true; 
            if (!f) {                
                return; 
            }
            console.log("onFileChange_HV_Quiz 2");
            const reader = new FileReader();
            reader.onload = (e) => {
               // try {
               
                const text = e.target.result;
                const json = JSON.parse(text);
                let errorCount = 0;
                for(let jsonitem of json)
                { 
                    let checkResult = this.check_validation_HVQuiz(jsonitem);
                    if(checkResult.ok == false){
                        //console.log("에러 -->  " + checkResult.msg );
                        errorCount++;
                        this.enableUplaod_HVQuiz = false;
                        //return;
                    }else{
                        //break;
                    }
                    
                }
                if( !this.enableUplaod_HVQuiz){
                    alert("에러가 있어서 검토가 필요합니다. 에러갯수 : " + errorCount );
                }
                
                //this.enableUplaod_HVQuiz = true; 
                // } catch (_) {
                //     this.enableUplaod_HVQuiz = false;
                // }
            };

            reader.readAsText(f, 'utf-8');
        },
     
        check_validation_HVQuiz(json) {
            if (!json || typeof json !== 'object') {
                return { ok: false, code: 100, msg: 'payload 타입 오류' };
            }

            const toClean = (v) => (typeof v === 'string'
                ? v.normalize('NFC').replace(/[\u200B\u200C\u200D\uFEFF]/g, '').trim()
                : '');

            const key     = json.key;
            const quiz_1  = toClean(json.quiz_1);
            const quiz_2  = toClean(json.quiz_2);
            const keyword = toClean(json.keyword);
            const answer  = toClean(json.answer);

            const dbg = (msg, ...rest) => {
                //  if (key === '301764'){  }
                console.log(`[DBG ${key}] ${msg}`, ...rest);
            };

            // if (key === '301764') {
            //     dbg('키값확인', { quiz_1, quiz_2, keyword, answer });
            // }

            // 1) 선행 규칙
            if (keyword.length !== 1) { 
                console.log("ERR : keyword는 1글자만 ", key , keyword);
                return { ok:false, code:101, msg:'keyword는 정확히 1글자' };                
             }
            if (!quiz_1 || !quiz_2)   { return { ok:false, code:102, msg:'quiz_1/quiz_2 누락' }; }
            if (quiz_1.includes(' ')) { return { ok:false, code:103, msg:'quiz_1 공백 금지' }; }
            if (quiz_2.includes(' ')) { return { ok:false, code:104, msg:'quiz_2 공백 금지' }; }
            if (!quiz_1.includes(keyword)) { return { ok:false, code:105, msg:'quiz_1은 keyword 포함' }; }
            if (!quiz_2.includes(keyword)) { return { ok:false, code:106, msg:'quiz_2는 keyword 포함' }; }

            // 1-추가) keyword 정확히 1회
            const countOccur = (s, k) => { let c = 0; for (const ch of s) { if (ch === k) c++; } return c; };
            const k1 = countOccur(quiz_1, keyword);
            const k2 = countOccur(quiz_2, keyword);
            if (k1 !== 1) { 
                //console.log("ERR : keyword는 1글자만 ", key , keyword);
                dbg(quiz_1 , ' <-> ', quiz_2 , '  키값확인 - 실패 (','-',keyword,')' , answer );
                return { ok:false, code:107, msg:`quiz_1 keyword 1회 규칙 위반 (${k1}회)` }; 
            }
            if (k2 !== 1) { 
                //console.log("ERR : keyword는 1글자만 ", key , keyword);
                dbg(quiz_1 , ' <-> ', quiz_2 , '  키값확인 - 실패 (','-',keyword,')' , answer );
                return { ok:false, code:108, msg:`quiz_2 keyword 1회 규칙 위반 (${k2}회)` }; 
            }

            // 2) answer 파싱
            const poolArr = answer.split('/').map(toClean).filter(s => s.length > 0);
            if (poolArr.length === 0) { return { ok:false, code:109, msg:'answer 풀이 비어 있음' }; }
            if (poolArr.includes(keyword)) { return { ok:false, code:110, msg:'answer에 keyword 포함 불가' }; }

            // 3) 멀티셋 구성
            const pool = new Map();
            for (const t of poolArr) pool.set(t, (pool.get(t) || 0) + 1);
            //dbg('키값확인2: 초기 pool', { size: pool.size, pool: Array.from(pool.entries()) });

            // 4) 소비 함수
            function consume(ch) {
                const cnt = pool.get(ch) || 0;
       
                if (cnt <= 0) {
                //dbg(`CONSUME 실패: '${ch}' 없음/부족 (현재=${cnt})`);
                 //dbg(quiz_1 , ' <-> ', quiz_2 , '  키값확인 - 실패 (',ch,'-',keyword,')' , answer );
                 dbg(quiz_1 , ' <-> ', quiz_2 , '  키값확인 - 실패 (',ch,')' , answer );
                return false;
                }
                pool.set(ch, cnt - 1);
                return true;
            }

            //dbg('키값확인3: 소비 시작 (quiz_1)');
            // 5) quiz_1 소비
            for (const ch of quiz_1) {
                if (ch === keyword) continue;
                if (!consume(ch)) {
                //dbg('키값확인3-FAIL: quiz_1에서 실패', ch, '현재 pool', Array.from(pool.entries()));
                //dbg(quiz_1 , ' <-> ', quiz_2 , '  키값확인4-FAIL: quiz_2에서 실패', ch, '현재 pool', Array.from(pool.entries()));
                    return { ok:false, code:111, msg:`quiz_1 소비 실패: '${ch}' 부족/미존재` };
                }
            }

            //dbg('키값확인4: 소비 시작 (quiz_2)', { afterQuiz1Pool: Array.from(pool.entries()) });
            // 6) quiz_2 소비
            for (const ch of quiz_2) {
                if (ch === keyword) continue;
                if (!consume(ch)) {
                //dbg(quiz_1 , ' <-> ', quiz_2 , '  키값확인4-FAIL: quiz_2에서 실패', ch, '현재 pool', Array.from(pool.entries()));
                return { ok:false, code:112, msg:`quiz_2 소비 실패: '${ch}' 부족/미존재` };
                }
            }

            //dbg('키값확인5: 소비 완료', { finalPool: Array.from(pool.entries()) });

            // 7) 잔여 검사 (원래 규칙 사용하려면 주석 해제)
            // for (const [ch, cnt] of pool.entries()) {
            //   if (cnt !== 0) {
            //     dbg('잔여 발견', ch, cnt);
            //     return { ok:false, code:113, msg:`answer 잔여: '${ch}' x ${cnt}` };
            //   }
            // }

            return { ok:true, code:0, msg:'valid' };
        },



        async upload_HV_Quiz(){
            let newFileName = `snapquiz/text_quiz_data/hv_text_quiz.json`;//item.commit_path || 

   
            const reader = new FileReader();
            reader.onload = async (e) => {
                try {
               
                const text = e.target.result;
                const json = JSON.parse(text);
                //console.log("onFileChange_HV_Quiz 3 " + text);
                
                const success = await FileUpload_JSON(json, newFileName);
                if (success) {
                    alert('퀴즈 업로드가 완료되었습니다.');
                } else {
                    alert('퀴즈 업로드에 실패했습니다. 잠시 후 다시 시도해주세요.');
                }       

                } catch (_) {
                    console.log("파일 읽기 실패 "  + _    );
                }
            };

            reader.readAsText(this.inputTemplate_HVQuiz, 'utf-8');
        },

        onFileChange_Select_Quiz(file) {
            console.log("onFileChange_Select_Quiz");
            var files = this.inputTemplate_SelectQuiz;// || e.dataTransfer.file;
            //inputTemplate_SelectQuiz =
            this.enableUplaod_SelectQuiz = true;
            //this.inputTemplate = files[0];
            //console.log(this.inputTemplate);
            
            //this.createImage(files[0]);
        },
        async upload_Select_Quiz(){
            let newFileName = `snapquiz/text_quiz_data/select_text_quiz.json`;//item.commit_path || 

   
            const reader = new FileReader();
            reader.onload = async (e) => {
                try {
               
                const text = e.target.result;
                const json = JSON.parse(text);
                console.log("onFileChange_HV_Quiz 3 " + text);
                
                const success = await FileUpload_JSON(json, newFileName);
                if (success) {
                    alert('퀴즈 업로드가 완료되었습니다.');
                } else {
                    alert('퀴즈 업로드에 실패했습니다. 잠시 후 다시 시도해주세요.');
                }       

                } catch (_) {
                    console.log("파일 읽기 실패 "  + _    );
                }
            };

            reader.readAsText(this.inputTemplate_SelectQuiz, 'utf-8');
        },

        OS_TagConvert(_os)
        {
            if(_os  == 0)
                return  "안드로이드";
            else
                return "아이폰";
        },
        openQuizLink_HV(){
            let quiz_link = "https://content-filecenter.s3.ap-northeast-2.amazonaws.com/snapquiz/text_quiz_data/hv_text_quiz.json";
            window.open(quiz_link, '_blank');
        },
        openQuizLink_Select(){
            let quiz_link = "https://content-filecenter.s3.ap-northeast-2.amazonaws.com/snapquiz/text_quiz_data/select_text_quiz.json";
            window.open(quiz_link, '_blank');
        },
        onFileChange_Nonsense_Quiz(file) {
            console.log("onFileChange_Nonsense_Quiz");
            const f = Array.isArray(file) ? file[0] : file;
            this.enableUplaod_NonsenseQuiz = true;
            if (!f) {
                this.enableUplaod_NonsenseQuiz = false;
                return;
            }
            // JSON 파일 검증
            const reader = new FileReader();
            reader.onload = (e) => {
                try {
                    const text = e.target.result;
                    const json = JSON.parse(text);
                    if (!Array.isArray(json)) {
                        alert("JSON 파일 형식이 올바르지 않습니다. 배열 형식이어야 합니다.");
                        this.enableUplaod_NonsenseQuiz = false;
                        return;
                    }
                    this.enableUplaod_NonsenseQuiz = true;
                } catch (error) {
                    alert("JSON 파일을 읽는 중 오류가 발생했습니다: " + error.message);
                    this.enableUplaod_NonsenseQuiz = false;
                }
            };
            reader.readAsText(f, 'utf-8');
        },
        async upload_Nonsense_Quiz(){
            let newFileName = `snapquiz/text_quiz_data/nonsense_text_quiz.json`;

            const reader = new FileReader();
            reader.onload = async (e) => {
                try {
                    const text = e.target.result;
                    const json = JSON.parse(text);
                    
                    const success = await FileUpload_JSON(json, newFileName);
                    if (success) {
                        alert('넌센스 퀴즈 업로드가 완료되었습니다.');
                        this.inputTemplate_NonsenseQuiz = null;
                        this.enableUplaod_NonsenseQuiz = false;
                    } else {
                        alert('넌센스 퀴즈 업로드에 실패했습니다. 잠시 후 다시 시도해주세요.');
                    }
                } catch (error) {
                    console.log("파일 읽기 실패 " + error);
                    alert('파일을 읽는 중 오류가 발생했습니다.');
                }
            };

            reader.readAsText(this.inputTemplate_NonsenseQuiz, 'utf-8');
        },
        onFileChange_OX_Quiz(file) {
            console.log("onFileChange_OX_Quiz");
            const f = Array.isArray(file) ? file[0] : file;
            this.enableUplaod_OXQuiz = true;
            if (!f) {
                this.enableUplaod_OXQuiz = false;
                return;
            }
            // JSON 파일 검증
            const reader = new FileReader();
            reader.onload = (e) => {
                try {
                    const text = e.target.result;
                    const json = JSON.parse(text);
                    if (!Array.isArray(json)) {
                        alert("JSON 파일 형식이 올바르지 않습니다. 배열 형식이어야 합니다.");
                        this.enableUplaod_OXQuiz = false;
                        return;
                    }
                    this.enableUplaod_OXQuiz = true;
                } catch (error) {
                    alert("JSON 파일을 읽는 중 오류가 발생했습니다: " + error.message);
                    this.enableUplaod_OXQuiz = false;
                }
            };
            reader.readAsText(f, 'utf-8');
        },
        async upload_OX_Quiz(){
            let newFileName = `snapquiz/text_quiz_data/ox_text_quiz.json`;

            const reader = new FileReader();
            reader.onload = async (e) => {
                try {
                    const text = e.target.result;
                    const json = JSON.parse(text);
                    
                    const success = await FileUpload_JSON(json, newFileName);
                    if (success) {
                        alert('OX 퀴즈 업로드가 완료되었습니다.');
                        this.inputTemplate_OXQuiz = null;
                        this.enableUplaod_OXQuiz = false;
                    } else {
                        alert('OX 퀴즈 업로드에 실패했습니다. 잠시 후 다시 시도해주세요.');
                    }
                } catch (error) {
                    console.log("파일 읽기 실패 " + error);
                    alert('파일을 읽는 중 오류가 발생했습니다.');
                }
            };

            reader.readAsText(this.inputTemplate_OXQuiz, 'utf-8');
        },
        openQuizLink_Nonsense(){
            let quiz_link = "https://content-filecenter.s3.ap-northeast-2.amazonaws.com/snapquiz/text_quiz_data/nonsense_text_quiz.json";
            window.open(quiz_link, '_blank');
        },
        openQuizLink_OX(){
            let quiz_link = "https://content-filecenter.s3.ap-northeast-2.amazonaws.com/snapquiz/text_quiz_data/ox_text_quiz.json";
            window.open(quiz_link, '_blank');
        },
        // 그림 퀴즈 관리 메서드
        LoadDrawingQuizList() {
            this.loadingDrawingQuiz = true;
            
            this.GET_DRAWING_QUIZ_LIST().then((body_data) => {
                this.drawingQuizList = body_data.result || [];
                this.loadingDrawingQuiz = false;
            }).catch((err) => {
                console.error('그림 퀴즈 리스트 불러오기 실패:', err);
                this.loadingDrawingQuiz = false;
            });
        },
        OnClick_CreateDrawingQuiz() {
            this.editingDrawingQuizItem = null;
            this.drawingQuizDialog_correct = "";
            this.drawingQuizDialog_answer = "";
            this.drawingQuizImageFile = null;
            this.drawingQuizDialog = true;
        },
        OnEditDrawingQuiz_Item(item) {
            this.editingDrawingQuizItem = item;
            this.drawingQuizDialog_correct = item.correct || "";
            this.drawingQuizDialog_answer = item.answer || "";
            this.drawingQuizImageFile = null; // 새 이미지 선택 시에만 사용
            this.drawingQuizDialog = true;
        },
        handleDrawingQuizFileChange(file) {
            this.drawingQuizImageFile = file;
        },
        async CreateDrawingQuiz() {
            if(this.drawingQuizDialog_correct.replace(/\s/g, '') == "" || this.drawingQuizDialog_answer.replace(/\s/g, '') == "") {
                alert("미입력한 정보가 있습니다.");
                return;
            }

            if(this.drawingQuizImageFile == null){
                alert("이미지 등록이 필요합니다.");
                return;
            }   
            
            this.loadingDrawingQuiz = true;
            this.drawingQuizDialog = false;
            
            var newFileName = "snapquiz/drawing_quiz_img/"+this.Utill_CreateNewImageName(this.drawingQuizImageFile.name);
            const awaitResult = await FileUpload_Async(this.drawingQuizImageFile, newFileName);
            
            if(awaitResult) {
                this.loadingDrawingQuiz = false;
                let img_path = newFileName;         
                let correct = this.drawingQuizDialog_correct;       
                let answer = this.drawingQuizDialog_answer;
                let activate = 'Y'; // 기본값

                this.CREATE_DRAWING_QUIZ({ correct, answer, img_path, activate }).then((body_data) => {
                    this.LoadDrawingQuizList();
                    ///alert('그림 퀴즈가 등록되었습니다.');
                }).catch((err) => {
                    console.error('그림 퀴즈 등록 실패:', err);
                    alert('그림 퀴즈 등록에 실패했습니다.');
                });
            }
        },
        async SaveDrawingQuiz() {
            if(this.drawingQuizDialog_correct.replace(/\s/g, '') == "" || this.drawingQuizDialog_answer.replace(/\s/g, '') == "") {
                alert("미입력한 정보가 있습니다.");
                return;
            }

            if(!this.editingDrawingQuizItem) {
                alert("수정할 항목이 없습니다.");
                return;
            }
            
            this.loadingDrawingQuiz = true;
            this.drawingQuizDialog = false;
            
            let pid = this.editingDrawingQuizItem.pid;
            let correct = this.drawingQuizDialog_correct;
            let answer = this.drawingQuizDialog_answer;
            let img_path = this.editingDrawingQuizItem.img_path;
            let activate = this.editingDrawingQuizItem.activate || 'Y';
            
            // 이미지가 변경된 경우
            if(this.drawingQuizImageFile != null) {
                var newFileName = "snapquiz/drawing_quiz_img/"+this.Utill_CreateNewImageName(this.drawingQuizImageFile.name);
                const await_result = await FileUpload_Async(this.drawingQuizImageFile, newFileName);
                
                if(await_result) {
                    img_path = newFileName;
                } else {
                    this.loadingDrawingQuiz = false;
                    alert('이미지 업로드에 실패했습니다.');
                    return;
                }
            }
            
            this.EDIT_DRAWING_QUIZ({ pid, correct, answer, img_path, activate }).then((body_data) => {
                this.loadingDrawingQuiz = false;
                this.LoadDrawingQuizList();
                alert('수정완료');
            }).catch((err) => {
                console.error('그림 퀴즈 수정 실패:', err);
                this.loadingDrawingQuiz = false;
                alert('수정에 실패했습니다.');
            });
        },
        OnDeleteDrawingQuiz_Item(item) {
            if (confirm("정말 삭제하시겠습니까?")) {
                let pid = item.pid;
                
                this.DELETE_DRAWING_QUIZ({ pid }).then((body_data) => {
                    this.LoadDrawingQuizList();
                    alert('삭제완료');
                }).catch((err) => {
                    console.error('그림 퀴즈 삭제 실패:', err);
                    alert('삭제에 실패했습니다.');
                });
            }
        },
        CancelDrawingQuizEdit() {
            this.drawingQuizDialog = false;
        },
        Utill_CreateNewImageName(originalFileName) {
            // 확장자 추출
            const fileExtension = originalFileName.substring(originalFileName.lastIndexOf('.'));
            // 랜덤 문자열 생성 (16자)
            const randomString = Math.random().toString(36).substring(2, 18);
            // 새 파일 이름 생성
            return randomString + fileExtension;
        },
        // 그림 퀴즈 유효성 검사: 썸네일 존재 여부 및 선택지로 정답 조합 가능 여부
        isDrawingQuizValid(item) {
            // 1. 썸네일 체크
            if(!item.img_path || item.img_path.trim() === '') {
                return false;
            }
            
            // 2. 정답과 선택지가 있는지 체크
            if(!item.correct || !item.answer) {
                return false;
            }
            
            // 3. 선택지로 정답을 조합할 수 있는지 체크
            const correct = item.correct.trim();
            const answer = item.answer.trim();
            
            if(correct === '' || answer === '') {
                return false;
            }
            
            // 선택지를 "/"로 쪼개기
            const answerParts = answer.split('/').map(part => part.trim()).filter(part => part.length > 0);
            
            if(answerParts.length === 0) {
                return false;
            }
            
            // 선택지에서 "/"를 제거한 전체가 정확히 12글자인지 확인
            const answerWithoutSlash = answerParts.join('');
            if(answerWithoutSlash.length !== 12) {
                return false;
            }
            
            // 정답이 선택지 부분들의 조합으로 만들 수 있는지 확인
            // 각 부분을 통째로 사용해야 함 (부분적으로 사용 불가)
            // 백트래킹 방식으로 정답을 만들 수 있는지 확인
            const canMakeCorrect = (target, parts, used) => {
                if(target === '') {
                    return true; // 정답을 모두 만들었음
                }
                
                // 사용하지 않은 부분 중에서 정답의 시작 부분과 일치하는 것이 있는지 확인
                for(let i = 0; i < parts.length; i++) {
                    if(used[i]) continue; // 이미 사용한 부분은 건너뛰기
                    
                    if(target.startsWith(parts[i])) {
                        // 이 부분을 사용할 수 있음
                        used[i] = true;
                        const remaining = target.substring(parts[i].length);
                        if(canMakeCorrect(remaining, parts, used)) {
                            return true;
                        }
                        // 백트래킹: 이 부분을 사용하지 않고 다른 조합 시도
                        used[i] = false;
                    }
                }
                
                return false;
            };
            
            const used = new Array(answerParts.length).fill(false);
            return canMakeCorrect(correct, answerParts, used);
        }
    },
    computed: {
        isLive(){
            return config.isLive;
        },
        computedDateFormattedMomentjs_begin () {
            return this.date_begin ? moment(this.date_begin).format('YYYY-MM-DD') : ''
        },
        computedDateFormattedMomentjs_end () {
            return this.date_end ? moment(this.date_end).format('YYYY-MM-DD') : ''
        },  
    },
    components:{
    },
    watch :{
            '$store.state.selected_game_package': function() {
            console.log("WHAT IS THIS? " + this.$store.state.selected_game_package)
            this.Refresh_TempatleLogs();
        }
    }
};
</script>

<style scoped>
.error-row {
    background-color: #ffebee !important;
}
.error-row td {
    background-color: #ffebee !important;
}
</style>
